import React, { useState } from "react";
import $ from 'jquery';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import { contScrollToBottom, contScrollToTop, hideScrolltoBottomHandler, hideScrolltoTopHandler } from "../../JS/scroll";
import MiniLoader from "../../UI/MiniLoader";
import CancelReservationPopupV2 from "./cancelReservationPopupV2";

const MyResReservationV2 = (props) => {

	const { t } = props
	const [showContainer, setShowContainer] = useState(true);
	const [showCancelReservation, setShowCancelReservation] = useState(false);
	const [cancelReservationId, setCancelReservationId] = useState(null)
	const [myReservationDataAsPerVenue, setMyreservationDataAsPerVenue] = useState([]);
	const [groupedMyReservationData, setGroupMyReservationData] = useState(new Map());

	const formatDate = (dateString) => {
		console.log(dateString, "dateString");
		const date = new Date(dateString);
		const today = props.serverTimeDate
			? new Date(props.serverTimeDate.split("T")[0])
			: new Date();

		// Clear the time part for comparison
		today.setHours(0, 0, 0, 0);
		date.setHours(0, 0, 0, 0);

		const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
		const diffInTime = date.getTime() - today.getTime();
		const diffInDays = diffInTime / oneDayInMilliseconds;


		if (diffInDays === 0) {
			return "Today";
		} else if (diffInDays === -1) {
			return "Yesterday";
		} else if (diffInDays === 1) {
			return "Tomorrow";
		} else {
			return `${dateFormatHandler(
				new Date(dateString).toISOString(),
				props.dateFormat
			)}`;
		}
	};

	const filterBySelectedVenue = (myReservationData) => {

		let requiredVenueData = [];

		myReservationData.forEach((singleReservationData) => {
			if(!props.selectedVenueId || props.selectedVenueId == ""){
				requiredVenueData.push(singleReservationData);
			} else {
				if(singleReservationData.venue_id == props.selectedVenueId){
					requiredVenueData.push(singleReservationData);
				}
			}
		})

		return requiredVenueData;
	}

	const groupingByDate = (data) => {
		const groupedAccToDay = new Map();

		data.sort((a, b) => {
			return new Date(a.real_datetime_of_slot).getTime() - new Date(b.real_datetime_of_slot).getTime()
		})
		console.log(data)
		data.forEach((d) => {
			const groupingKey = d.date;
			if (groupedAccToDay.has(groupingKey)) {
				const keyData = groupedAccToDay.get(groupingKey);
				keyData.push(d);
			} else {
				groupedAccToDay.set(groupingKey, [d]);
			}
		});

		console.log(groupedAccToDay, 'groupedAccToDay')
		return groupedAccToDay;
	};


	React.useEffect(() => {
		if(myReservationDataAsPerVenue.length > 0) setGroupMyReservationData(groupingByDate(myReservationDataAsPerVenue))
	},[myReservationDataAsPerVenue])

	React.useEffect(() => {
		setMyreservationDataAsPerVenue(filterBySelectedVenue(props.myReservationData));
	},[props.myReservationData])


	return (
		<>

			<section class="widgets spa-listing spa-details">
				<div class="widgets">
					<div class="gallery-slides itinerary-list">

						<div class="form-row-heading">
							{myReservationDataAsPerVenue.length > 1
								? t("resReservationV2.myReservations")
								: t("resReservationV2.myReservation")}</div>

						{props.fetchingMyReservation ?

							<MiniLoader />

							: showContainer ?


							myReservationDataAsPerVenue.length > 0 ?
									<>

										{Array.from(groupedMyReservationData.entries()).map(
											([day, dataOnThatDay]) => {
												return (
													<div class="list-items-container">
														<div class="list-item-heading">{formatDate(day)}</div>
														{dataOnThatDay.map((reservation) => {
															return (
																<div class="list-item">
																	<div class="list-item-contents">
																		<div class="list-item-name">{reservation.name}</div>
																		<div class="list-item-body">
																			{formatLocalTime(
																				new Date(reservation.real_datetime_of_slot),
																				toBool(props.timeFormat)
																			)}
																		</div>
																	</div>
																	<div class="list-item-opt">
																		{reservation.status == "CANCELED" ? (
																			<span class="status-cancelled">
																				{reservation.status_display}
																			</span>
																		) 
																		: reservation.status == "NOT_RECONCILED" ? (
																			<>
																				<button
																					onClick={() => {
																						props.editReservation(reservation);
																					}}
																				>
																					<i className="fas fa-pen"></i>
																				</button>
																				<button
																					onClick={() => {
																						setCancelReservationId(reservation.id);
																						setShowCancelReservation(true);
																					}}
																				>
																					<i className="fas fa-times"></i>
																				</button>
																			</>
																		) : (
																			<span class={"status-other"}>
																				{reservation.status_display}
																			</span>
																		)}
																	</div>
																</div>
															);
														})}
													</div>
												);
											}
										)}


									</>
									:
									<div className="no_reservation" >{t('resReservationV2.no_reservatino_found')}</div>
								: null
						}
					</div>
				</div>
			</section>
			{showCancelReservation && (
				<CancelReservationPopupV2
					cancelReservationId={cancelReservationId}
					handleDeleteReservation={(bool) => {
						setShowCancelReservation(false);
						props.handleDelete(bool);
					}}
					close={() => {
						setCancelReservationId(null);
						setShowCancelReservation(false);
					}}
				/>
			)}



		</>
	);
};

const mapStateToProps = (state) => {
	return {
		installedAppVersion: state.store.installedAppVersion,
		installedAppBuildNo: state.store.installedAppBuildNo,
		gmtOffset: state.store.home.serverTimeDate.gmtOffset,
		timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
		dateFormat: state.store.home.clientConfig.extraConfigParam
			? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
		serverTimeDate: state.store.home.serverTimeDate.date,
	};
};

export default connect(mapStateToProps, { closeOrderPopUp })(withTranslation('translations')(MyResReservationV2));